import { useCallback, useMemo, useState } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { useStyles } from "./styles";
import { useQuery } from "react-query";
import { listNotification } from "../../services/notifications";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import { difference } from "../../utils/date";
import { Notification as TNotification } from "../../types/notification";
import { useNavigate } from "react-router-dom";
import Chip from "@mui/material/Chip";

export function Notification() {
  const navigate = useNavigate();
  const styles = useStyles();

  const [filterRead, setFilterRead] = useState<number>(2);

  const notifications = useQuery("notifications", listNotification, {
    refetchOnWindowFocus: "always",
  });

  const handleReadNotify = useCallback(
    (data: TNotification) => {
      navigate(data.id, { state: data });
    },
    [navigate]
  );

  const notifies = useMemo(() => {
    if (filterRead === 1) {
      return notifications.data?.filter((data) => Boolean(data.read));
    } else if (filterRead === 0) {
      return notifications.data?.filter((data) => !Boolean(data.read));
    } else {
      return notifications.data;
    }
  }, [notifications.data, filterRead]);

  const handleFilterNotifications = useCallback((type: number) => {
    setFilterRead(type);
  }, []);

  return (
    <Container maxWidth="sm">
      <Stack spacing={2}>
        <Box className={styles.root} paddingY={2}>
          <Chip
            size="small"
            color="primary"
            variant={filterRead === 2 ? "filled" : "outlined"}
            label="Todas"
            onClick={() => {
              handleFilterNotifications(2);
            }}
          />
          <Chip
            size="small"
            color="primary"
            variant={filterRead === 1 ? "filled" : "outlined"}
            label="Lidas"
            onClick={() => {
              handleFilterNotifications(1);
            }}
          />
          <Chip
            size="small"
            color="primary"
            variant={filterRead === 0 ? "filled" : "outlined"}
            label="Não lidas"
            onClick={() => {
              handleFilterNotifications(0);
            }}
          />
        </Box>
        <Box
          className={styles.root}
          height="74vh"
          alignItems="initial"
          overflow="overlay"
        >
          {notifications.isLoading ? (
            <Stack
              py={2}
              spacing={1}
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <Typography variant="subtitle1">Buscando notificações</Typography>
              <LinearProgress variant="indeterminate" sx={{ width: "50%" }} />
            </Stack>
          ) : (
            <nav aria-label="main mailbox folders">
              <List disablePadding dense>
                {notifies?.map((data, index) => (
                  <ListItemButton
                    onClick={() => {
                      handleReadNotify(data);
                    }}
                    className={!Boolean(data.read) ? styles.unread : undefined}
                    sx={{
                      borderRadius:
                        index === 0
                          ? "0.5rem 0.5rem 0 0"
                          : notifies.length - 1 === index
                          ? "0 0 0.5rem 0.5rem"
                          : undefined,
                    }}
                    key={data.id}
                  >
                    <Stack px={1} py={2} direction="row" spacing={2}>
                      <Badge
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        color="primary"
                        variant="dot"
                        invisible={Boolean(data.read)}
                      >
                        <Avatar
                          variant="rounded"
                          sx={{ backgroundColor: "#F7B303" }}
                        >
                          <SmartToyIcon />
                        </Avatar>
                      </Badge>

                      <Stack spacing={1}>
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Typography
                            sx={{ fontSize: "12pt" }}
                            color="text.primary"
                          >
                            {data.title.length < 40
                              ? data.title
                              : `${data.title.slice(0, 40)} ...`}
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            sx={{ fontSize: "8pt", whiteSpace: "nowrap" }}
                            color="text.secondary"
                          >
                            {difference(data.sendingAt)}
                          </Typography>
                        </Stack>
                        <Typography
                          sx={{ fontSize: "10pt" }}
                          color="text.secondary"
                        >
                          {`${data.description.slice(0, 100)} ...`}
                        </Typography>
                      </Stack>
                    </Stack>
                  </ListItemButton>
                ))}
              </List>
            </nav>
          )}
        </Box>
      </Stack>
    </Container>
  );
}
